import PasswordBox from "../../PasswordBox/PasswordBox";
import { useState } from "react";
import FullScreenPop from "../FullScreenPop";
import "./DeleteAccount.css";
import "../../Button/Button.css";

export default function DeleteAccount(props) {
    const [password, setPassword] = useState("");
    const [check, setCheck] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    return <FullScreenPop
        header="⚠ Delete Account"
        closePop={() => props.close(false)}
        component={<>
            <p>Deleting your account cannot be undone.</p>
            <form id="deleteAccountForm"
                onSubmit={(e) => {
                    e.preventDefault();
                    setErrorMessage(false);
                    if (password && check) {
                        //console.log(password, check)
                        props.delete(password);
                    }
                }}>
                {(errorMessage || !props.errorMessage) &&
                    <p className="error-message">
                        {errorMessage ? errorMessage : props.errorMessage}
                    </p>}
                <PasswordBox
                    password={password}
                    onChange={setPassword}
                />
                <div>
                    <input
                        type="checkbox"
                        id="confirm-delete"
                        name="confirm-delete"
                        value={check}
                        onChange={(e) => { setCheck(e.target.checked) }}
                    />
                    <label htmlFor="confirm-delete" className="delete-p">
                        I understand deleting my account means all data I have created on this website
                        will be permanently deleted and cannot be undone.
                    </label>
                </div>

                <input
                    type="submit"
                    value="Delete Account"
                    id="submit"
                    className="icon-button--red"
                    // utilizing false as a loading value instead of creating a variable
                    disabled={(errorMessage === false && !props.errorMessage) 
                        || !(password && check)}
                />

            </form>
        </>}
    />
}